// extracted by mini-css-extract-plugin
export default {"icon":"ExpandIcon-module__icon--4140","open":"ExpandIcon-module__open--6054"};